import { useLayoutEffect, useState, type ReactNode } from "react";
import { flushSync } from "react-dom";

type VTDocument = Document & {
  startViewTransition?: (callback: () => void) => unknown;
};

const reducedMotion = () =>
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;

export function Crossfade<T extends string>(props: {
  value: T;
  render: (value: T) => ReactNode;
}) {
  const { value, render } = props;
  const [shown, setShown] = useState(value);

  useLayoutEffect(() => {
    if (shown === value) return;
    const swap = () => flushSync(() => setShown(value));
    const doc = document as VTDocument;
    if (typeof doc.startViewTransition === "function" && !reducedMotion()) {
      doc.startViewTransition(swap);
    } else {
      swap();
    }
  }, [value, shown]);

  return render(shown);
}
